import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { flightClassTourOptionPropTypes } from './PropTypes';

import UpgradeCard from '../BookingFieldset/UpgradeCard';
import {
  currencyWithPriceAndFormattedPricePropTypes,
  getCurrencyPriceFromCurrencyOptions,
} from '../../../util/currency';

const propTypes = exact({
  currencyPriceSetting: currencyWithPriceAndFormattedPricePropTypes,
  currencySymbol: PropTypes.string.isRequired,
  optionKey: PropTypes.string.isRequired,
  groupIndex: PropTypes.number.isRequired,
  handleOptionSelect: PropTypes.func.isRequired,
  optionAddedText: PropTypes.string,
  options: PropTypes.arrayOf(flightClassTourOptionPropTypes).isRequired,
  selectedKey: PropTypes.string,
  soldOutText: PropTypes.string.isRequired,
  stopoverDataKey: PropTypes.string,
  perPersonText: PropTypes.string,
});

const defaultProps = {
  selectedKey: '',
  optionAddedText: '',
  stopoverDataKey: '',
  perPersonText: 'pp',
};

function FlightClassGroup(props) {
  const {
    optionKey,
    groupIndex,
    handleOptionSelect,
    stopoverDataKey,
    currencyPriceSetting,
    currencySymbol,
    perPersonText,
  } = props;

  return (
    <div className="UpgradeGroup">
      <div className="UpgradeGroup_itemGroup">
        {props.options.map((flightClassTourOption) => {
          const currencyPriceSettingPrice = getCurrencyPriceFromCurrencyOptions(
            flightClassTourOption.pricePerPax[0].pricePerCurrency,
            currencyPriceSetting.currency
          );
          return (
            <div className="UpgradeGroup_item" key={flightClassTourOption.key}>
              <UpgradeCard
                // arrivalDate={flightClassTourOption.arrivalDate}
                // arrivalTime={flightClassTourOption.arrivalTime}
                blockName="UpgradeGroup_card"
                currencySymbol={currencySymbol}
                description={flightClassTourOption.option.fullDescription}
                // departureDate={flightClassTourOption.departureDate}
                // departureTime={flightClassTourOption.departureTime}
                handleClick={() =>
                  handleOptionSelect(
                    groupIndex,
                    optionKey,
                    flightClassTourOption.key,
                    stopoverDataKey
                  )
                }
                isSelected={flightClassTourOption.key === props.selectedKey}
                limitedAvailability={flightClassTourOption.limitedAvailability}
                limitedAvailabilityText={flightClassTourOption.limitedAvailabilityText}
                limitedAvailabilityRemainingText={flightClassTourOption.limitedAvailabilityText}
                limitedAvailabilityRemainingSpaces={
                  flightClassTourOption.limitedAvailabilityRemainingSpaces
                }
                perPersonText={perPersonText}
                price={currencyPriceSettingPrice}
                pricePerPerson
                selectedText={props.optionAddedText}
                soldOut={flightClassTourOption.soldOut}
                soldOutText={props.soldOutText}
                title={flightClassTourOption.option.title}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

FlightClassGroup.propTypes = propTypes;
FlightClassGroup.defaultProps = defaultProps;

export default FlightClassGroup;
